import { LIMIT_OF_CHARACTERS } from '~/shared/constants';
import { validate, validator } from '~/shared/helpers/validation-helpers';

const getChangePasswordFormConfig = ({
  t,
  isFooterReverse,
  isFixedActions,
}: {
  t: (key: string, options: { ns: string[] }) => string;
}) => {
  const validation = validator({ t });

  return {
    name: 'changePassword',
    pattern: 'basicFormPattern',
    isFooterReverse,
    isFixedActions,
    initialValues: {
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
    },
    position0: {
      title: t('text.change-password'),
    },
    position1: {
      formFields: [
        {
          name: 'oldPassword',
          label: t('field.old-password.title'),
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.PASSWORD.MIN,
              max: LIMIT_OF_CHARACTERS.PASSWORD.MAX,
            }),
          ]),
          type: 'password',
        },
        {
          name: 'newPassword',
          label: t('field.new-password.title'),
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.PASSWORD.MIN,
              max: LIMIT_OF_CHARACTERS.PASSWORD.MAX,
            }),
          ]),
          type: 'password',
          config: {
            withChecker: true,
          },
        },
        {
          name: 'newPasswordConfirmation',
          label: t('field.new-password-confirmation.title'),
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.PASSWORD.MIN,
              max: LIMIT_OF_CHARACTERS.PASSWORD.MAX,
            }),
          ]),
          type: 'password',
          config: {
            withChecker: true,
          },
        },
      ],
    },

    actions: {
      buttons: [
        {
          name: 'submit',
          htmlType: 'submit',
          className: 'call-to-action-button--purple',
          size: 'large',
          buttonName: t('button.save'),
          config: {
            isBlock: true,
          },
        },
      ],
    },
  };
};

export default getChangePasswordFormConfig;
